import { render, staticRenderFns } from "./WelcomeSwiper.vue?vue&type=template&id=51a6904e"
import script from "./WelcomeSwiper.vue?vue&type=script&lang=js"
export * from "./WelcomeSwiper.vue?vue&type=script&lang=js"
import style0 from "./WelcomeSwiper.vue?vue&type=style&index=0&id=51a6904e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports